var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('i',{staticClass:"custom-svg-icon",style:(_vm.getIconStyles())}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }